// Angular Files
import { Injectable } from '@angular/core';

// Other External Files
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Teller Online Files
import { CoreModule } from 'apps/admin-portal/src/app/core/core.module';
import { AdminPaymentsApiClient } from 'apps/admin-portal/src/app/core/api/AdminPortalApiClients';
import {
    ActivityLogModel,
    TellerOnlinePaymentActivityResponseModel
} from 'apps/admin-portal/src/app/core/services/admin-payment-activity.service';

// Teller Online Library Files
import {
    SearchSettingsModel,
    TellerOnlineDataSourceCompatible
} from 'teller-online-libraries/core';

@Injectable({
    providedIn: CoreModule
})
export class AdminScheduledPaymentActivityService
    implements TellerOnlineDataSourceCompatible<
        ActivityLogModel,
        TellerOnlinePaymentActivityResponseModel> {
    constructor(private adminPaymentsApiClient: AdminPaymentsApiClient) {}

    public loadDataSource(
        settings: SearchSettingsModel,
        scheduledPaymentInstanceGuid: string
    ): Observable<TellerOnlinePaymentActivityResponseModel> {
        return this.adminPaymentsApiClient
            .getScheduledPaymentActivity(settings.toDto(), scheduledPaymentInstanceGuid)
            .pipe(map(response => new TellerOnlinePaymentActivityResponseModel({
                    results: response.results.map(p => new ActivityLogModel(p)),
                    totalResults: response.totalResults
                })));
    }
}
